import { useCallback, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import OverlappingIcons from './OverlappingIcons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_VISIBLE_ICONS = 3;
export const OverlappingIconsButton = ({
  icons = [],
  onClick,
  children,
  selected = false,
  // Background Color Props
  backgroundColor = 'fill-surface-default',
  selectedBackgroundColor = 'fill-surface-recessed',
  // Border Style Props
  borderWidth,
  borderStyle,
  borderColor,
  selectedBorderColor = borderColor
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleClick = useCallback(event => {
    onClick === null || onClick === void 0 || onClick(event);
  }, [onClick]);
  const visibleIcons = icons.slice(0, MAX_VISIBLE_ICONS);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: selected || isHovered ? selectedBackgroundColor : backgroundColor,
    borderRadius: "400",
    inlineSize: "fit-content",
    padding: "0",
    borderWidth: "0",
    children: /*#__PURE__*/_jsx(Button, {
      use: "unstyled",
      onClick: handleClick,
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      block: true,
      padding: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        paddingBlock: "100",
        paddingInline: "250",
        borderWidth: borderWidth,
        borderStyle: borderStyle,
        borderColor: selected || isHovered ? selectedBorderColor : borderColor,
        borderRadius: "400",
        children: [/*#__PURE__*/_jsx(OverlappingIcons, {
          icons: visibleIcons
        }), children]
      })
    })
  });
};